import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as _ from 'lodash';
import { BooleanDate } from '../models/boolean-date.model';


const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExportExcelService {

  workbook: XLSX.WorkBook = XLSX.utils.book_new();
  // workSheets: XLSX.WorkSheet;
  // sheetNames: string[] = [];

  constructor() { }

  public addSheet(json: any[], sheetName: string, removeFields: string[] = ['']): void {

    // clone the data so the removals aren't persisted
    // const data: any[] = Object.assign({}, json);
    console.log(json);
    const data: any[] = _.cloneDeep(json);
    console.log(data);

    // remove the fields if they exists
    if (data !== undefined) {

      data.forEach(function (j) {

        // remove certain fields
        removeFields.forEach(function (field) {
          delete j[field];
        });


        Object.keys(j).forEach(function(key, index) {
          // key: the name of the object key
          // index: the ordinal position of the key within the object
          // console.log(j[key]);

          if ( j[key] instanceof BooleanDate ) {

            console.log('boolean date', j[key]);

            j[key + '_checked'] = j[key].checked;
            j[key + '_date'] = j[key].timestamp;

            // remove the original
            delete j[key];
          }

        });


        // for spliutting boolean dates
        // Object.keys(j).forEach(function (key, index) {

        //   // key: the name of the object key
        //   console.log(Object.prototype.toString.call(key));

        //   // index: the ordinal position of the key within the object
        //   if (Object.prototype.toString.call(key) === 'BooleanDate') {
        //     console.log(key);
        //   }
        // });

        // if is boolean date then change
        // j.forEach(function (field) {

        // });

      });
    }

    // create the worksheet from the workbook
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    /* Add the worksheet to the workbook */
    XLSX.utils.book_append_sheet(this.workbook, worksheet, sheetName);

  }

  public booleanDate() {


  }

  // public export

  public saveFile(excelFileName: string) {

    const excelBuffer: any = XLSX.write(this.workbook, { bookType: 'xlsx', type: 'array' });

    this.saveAsExcelFile(excelBuffer, excelFileName);

    // then reset the book for the next run through
    this.resetWorkBook();

  }

  public resetWorkBook() {

    // reset the book
    this.workbook = XLSX.utils.book_new();

  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    // const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}



// WEBPACK FOOTER //
// ./client/app/shared/export-excel/export-excel.service.ts